// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30-Su","placeholdersHeader":"styles_placeholdersHeader__3YRU2","editorStyle":"styles_editorStyle__USz5l","placeholdersBox":"styles_placeholdersBox__2nxDj"};